<template>
  <div class="overlay">
    <div class="page-lock">
      <div class="page-logo">
        <a class="brand" href="/">
          <img src="/static/pages/img/logo.png" alt="logo" />
        </a>
      </div>
      <div class="page-body">
        <div class="lock-head">Two-Step Verification</div>
        <div class="lock-body">
          <form
            class="two-factor-form-wrapper"
            @submit.prevent="handleFormSubmit"
          >
            <h4 class="text-center mb-20 fw-400">
              Enter the verification code we emailed <br />
              you to {{ email }}
            </h4>
            <div class="alert alert-danger" v-show="errorMessage !== null">
              <button class="close" data-close="alert"></button>
              <span>{{ errorMessage }}</span>
            </div>
            <div class="two-factor-form">
              <div class="mb-20">
                <input
                  class="form-control placeholder-no-fix two-factor-form__input"
                  type="text"
                  autocomplete="off"
                  placeholder="6-Digit Code"
                  name="password"
                  v-model="verificationCode"
                />
              </div>
              <div class="two-factor-form__buttons">
                <button
                  type="submit"
                  class="
                    btn btn-warning btn--big
                    uppercase
                    ladda-button
                    js-submit-btn
                  "
                  data-style="expand-left"
                >
                  <span class="ladda-label">Sign In</span>
                </button>
                <button
                  class="btn default btn--big uppercase"
                  @click.prevent="handleCancel"
                >
                  <span class="ladda-label">Cancel</span>
                </button>
              </div>
            </div>
          </form>
        </div>
        <div class="lock-bottom">
          <p class="mt-0"><strong>Need a new code?</strong></p>
          <p>
            <a
              href="#"
              class="green"
              @click.prevent="handleSendVerificationCodeAgain"
              >Email me with new code.</a
            >
          </p>
        </div>
      </div>
      <div class="page-footer-custom">
        © {{ getCurrentYear }} CaseMGR Solutions, Inc. All Rights Reserved.
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import Router from "@/router";

export default {
  name: "LoginTwoFactor",
  data() {
    return {
      verificationCode: null,
      loadingContext: null,
      errorMessage: null,
      email: localStorage.getItem("casemgr-2fa-email"),
      token: localStorage.getItem("casemgr-2fa-token"),
    };
  },
  computed: {
    getCurrentYear: function () {
      const d = new Date();
      let year = d.getFullYear();
      return year;
    },
  },
  methods: {
    ...mapActions({
      login: "LOGIN_TWO_FACTOR_ACTION",
      resendCode: "SEND_AGAIN_TWO_FACTOR_CODE_ACTION",
    }),

    handleFormSubmit() {
      if (this.verificationCode === null) {
        return;
      }

      this.loadingContext = Ladda.create(
        document.querySelector(".js-submit-btn")
      );

      this.login({
        code: this.verificationCode,
        token: this.token,
        context: this.loadingContext,
      })
        .then((response) => {
          this.token = response.data.data.token;
          if (response.data.data.message) {
            this.errorMessage = response.data.data.message;
          }
          console.log(response);
        })
        .finally(() => {
          if (this.loadingContext) {
            this.loadingContext.stop();
          }
        });
    },
    handleCancel() {
      if (this.loadingContext) {
        this.loadingContext.stop();
      }
      Router.push("login");
    },
    handleSendVerificationCodeAgain() {
      this.resendCode({
        token: this.token,
      }).then((response) => {
        this.token = response.data.data.token;
        if (response.data.data.message) {
          this.errorMessage = response.data.data.message;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.lock-bottom {
  a {
    text-shadow: none;
    color: #d09f23;
  }

  a:hover {
    color: #a77700;
  }

  a:focus,
  a:hover,
  a:active {
    outline: 0;
  }
}

.overlay {
  background-color: #ffffff;
  min-height: 100vh;
  min-width: 100vw;
  position: absolute;
}

.brand img {
  width: 100%;
}

.fw-400 {
  font-weight: 400;
}

.mb-20 {
  margin-bottom: 20px;
}

.two-factor-form-wrapper {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.two-factor-form {
  width: 250px;
  max-width: 100%;

  &__input {
    background-color: #ffffff;
    border: none;
    height: 40px;
    color: #697687;
  }

  &__buttons {
    display: flex;

    .btn {
      flex-grow: 1;
      margin-left: 10px;
      justify-content: center;

      &:first-child {
        margin-left: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// LoginTwoFactor.vue?6dd721f3